import Api from "./Api";
import store from "../state/store";

export default {
  addJourney(params) {
    return Api().post(`/journey_and_journey_flow`, params);
  },
  getJourneys() {
    return Api().get(
      `journey_and_journey_flow/${store.getters["authfack/currentEntity"].id}`,
      {
        params: {
          filterBy:
            Object.keys(store.getters["grid/getJourneyFilterValues"]).length > 0
              ? store.getters["grid/getJourneyFilterValues"]
              : {},
        }
      });
  },
  journeyDetails(id) {
    return Api().get(`/get_journey_and_journey_flow/${id}`);
  },
  getJourneyHost(id, flowId = null) {
    return Api().get(`/hosts/${id}`, { params: { journey_flow_id: flowId } });
  },
  getJourneyAttendanceModes(id) {
    return Api().get(`/attendance_modes/journey/${id}`);
  },
  updateJourney(params) {
    return Api().put(`/update_journey_and_journey_flow/${params.flowId}`, params.payload);
  },
  deleteJourney(id) {
    return Api().delete(`/delete_journey_and_journey_flow/${id}`);
  },
  getJourneysFlowandTypes(id, flowId = null) {
    const url = flowId ? `/journey_flow_and_check_user_type_by_joruney/${id}?journey_flow_id=${flowId}` : `/journey_flow_and_check_user_type_by_joruney/${id}`
    return Api().get(url);
  },
  validateJourneyFlow(params) {
    return Api().post(`/validate-update-journey-flow`,
      params
    );
  },
};
